import React from 'react';
import ProfileItems from '../../config/profile';
import OptionRow from './OptionRow';
import Header from '../Units/Header';
import '../../assets/stylesheets/ProfileSlide/ProfileTutorial.scss';

const Tutorial = () => {
    return(
        <React.Fragment>
            <Header title = 'tutorialTitle'/>
            <div className={`profileTutorial`}>
            {
                ProfileItems['tutorial'].map((option, index) => <OptionRow key={index} option={option} section="tutorial"></OptionRow>)
            }
            </div>
        </React.Fragment>
    )
}
export default Tutorial;
